export default __webpack_public_path__ + "static/mz-01b2fc27672e60ec8177b5edac3798fc.svg";